<template>
  <PageWrapper :maxWidth="5000">
    <b-row class="margin-0 margin-top-24">
      <b-col cols="12" class="padding-0">
        <div
          class="desktop-flex-start position-relative desktop-width-max-content"
        >
          <Input
            :value="form.searchTxt"
            name="searchTxt"
            id="searchTxt"
            type="text"
            :placeholder="$lang.search"
            :vuelidateObj="$v.form.searchTxt"
            :hasEraseIcon="!!form.searchTxt"
            :autoFocus="true"
            rightIcon="magnify"
            :loading="loading"
            @input="getSearchText"
            @erase="eraseSearchText"
          />
        </div>
      </b-col>
      <b-col cols="12" class="padding-0" v-if="!!items.length">
        <div class="font-size-16 color-complementary-400 margin-y-16">
          {{ generateTaskCountText }}
        </div>
        <div class="jobs-profile__search-content">
          <router-link
            v-for="(item, index) in items"
            :key="`a-${index}`"
            tag="div"
            :to="{ name: 'jobs-profile-detail', params: { id: item.id } }"
            class="color-primary font-size-14 text-decoration-underline cursor--pointer margin-bottom-8"
          >
            {{ item.title }}
          </router-link>
        </div>
      </b-col>
      <b-col
        v-else
        cols="12"
        class="padding-0 margin-top-16 flex-center flex-direction-column background-surface padding-y-16 border--solid border--complementary-50 border-radius-8"
      >
        <b-img-lazy
          class="empty-box__image width-181 margin-bottom-21"
          :src="generateEmptyImage"
        />
        <div class="empty-box__text color-complementary-300 font-size-14">
          {{ generateEmptyText }}
        </div>
      </b-col>
    </b-row>
  </PageWrapper>
</template>

<script>
import inputMixin from "@/mixin/inputMixin.vue";
import PageWrapper from "@/components/re-design/wrappers/PageWrapper.vue";
import { Input } from "@/components/re-design/forms";
import { required } from "vuelidate/lib/validators";
import { pathOr, includes } from "ramda";
import {
  checkPermission,
  generateError,
  generateQueryString,
  storeDispatcher,
} from "@/shared/utils";
import { getJobsProfile } from "../services";

export default {
  mixins: [inputMixin],
  components: {
    PageWrapper,
    Input,
  },
  props: {
    emptyImage: {
      type: String,
      default: "",
    },
    emptyText: {
      type: String,
      default: "",
    },
  },
  validations() {
    return {
      form: {
        searchTxt: {},
      },
    };
  },
  data() {
    return {
      form: {
        searchTxt: null,
      },
      showSearchTxt: true,
      debounceGet: null,
      debounceTime: 800,
      loading: false,
      items: [],
    };
  },
  computed: {
    generateEmptyImage() {
      return this.$config.images.shared.redesign.empty.search;
    },
    generateEmptyText() {
      return this.$lang.noJobHasBeenSearched;
    },
    generateTaskCountText() {
      return this.$lang.showNumTask.replace("{0}", 10);
    },
  },
  watch: {
    url: {
      immediate: true,
      async handler(value) {
        if (value) {
          this.reload();
        }
      },
    },
    extraParams: {
      immediate: true,
      async handler(value) {
        if (value) {
          this.reload();
        }
      },
    },
  },
  methods: {
    pathOr,
    includes,
    checkPermission,
    generateQueryString,
    storeDispatcher,
    generateRouteUrl(id = 10) {
      const routerData = this.$router.resolve({
        name: "jobs-profile-detail",
        params: { id },
      });
      return routerData.href;
    },
    eraseSearchText() {
      // remove text search data
      this.form.searchTxt = null;
      this.items = [];
      this.fetchData();
    },
    getSearchText(key, value) {
      // call of input mixin
      this.input(key, value);

      if (this.debounceGet) {
        clearTimeout(this.debounceGet);
        this.debounceGet = null;
      }
      this.debounceGet = setTimeout(() => {
        this.fetchData();
      }, this.debounceTime);
    },
    async fetchData() {
      try {
        this.loading = true;
        const response = await getJobsProfile(this.form.searchTxt);
        const { items } = response;
        this.items = [...items];
      } catch (error) {
        generateError(error);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
